import React, { createContext, useContext } from "react";

export const InteractiveProductsSettingsContext = createContext(null);

export const useInteractiveProductsSettings = () => {
	const context = useContext(InteractiveProductsSettingsContext);

	if (context === null) {
		console.error("[Interactive-Products] InteractiveProductsSettingsContext is not provided");
		return null;
	}

	return context;
};

export const InteractiveProductsSettingsProvider = ({ children, value }) => {
	return (
		<InteractiveProductsSettingsContext.Provider value={value}>
			{children}
		</InteractiveProductsSettingsContext.Provider>
	);
};
